import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from "@angular/common/http";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "../../../../src/environment/environment";
const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Method": "POST",
    "Access-Control-Allow-Headers":
      "Access-Control-Allow-Headers,Content-Type,Access-Control-Allow-Methods, Authorization, X-Requested-With",
    "Access-Control-Request-Headers":
      "access-control-allow-origin, content-type",
  }),
};

@Injectable({
  providedIn: "root",
})
export class CommonService {
  headers: HttpHeaders | { [header: string]: string | string[] } = {}; // Initialize headers here
  // headers: HttpHeaders | { [header: string]: string | string[] };

  constructor(private httpClient: HttpClient) {}

  getCutomerDetailsById(data: any): any {
    return this.httpClient.post(
      environment.url + "/customers/masters/getCustomerDetailsById",
      data
    );
  }
  updateCustomerDetails(FormDetails: any) {
    return this.httpClient.post(
      environment.url +
        "/customers/masters/updateCustomerDetailsById",
      FormDetails
    );
  }
  sendMail(FormDetails: any) {
    return this.httpClient.post<boolean>(
      environment.url +
        "/customers/masters/actionsendMail",
      FormDetails
    );
  }
  logout(customerActionLogsId: any) {
    return this.httpClient.post<boolean>(
      environment.url +
        "/customers/auth/logout",
        {customerActionLogsId}
    );
  }
  projectSparePartDetails(data: any): any {
    return this.httpClient.post(
      environment.url + "/customers/masters/getProjectSparePartDetails",
      data
    );
  }

  deleteCustomerAuthorizedEmail(data: any) {
    return this.httpClient.post(
      environment.url + "/customers/masters/deleteCustomerAuthorizedEmail", data);
  }

  GetCustomersAllPOList(data: any): any {
    return this.httpClient.post(
      environment.url + "/customers/masters/getCustomersAllPOList", data
    );
  }

  createCustomerComplaints(FormDetails: any) {
    return this.httpClient.post(
      environment.url +
        "/customers/masters/createCustomerComplaints", FormDetails
    );
  }

  ComplaintsListByCustomerId(data: any): any {
    return this.httpClient.post(
      environment.url + "/customers/masters/complaintsListByCustomerId" ,
      data
    );
  }

  // complaint view api
  complainView(data: any): any {    
    return this.httpClient.post(
      environment.url +
        "/customers/masters/complaintsViewByComplaintId",data
    );
  }

  GetPODataForPieChart(data:any): any {
    return this.httpClient.post(
      environment.url +
      "/customers/masters/getPODataForPieChart", data
    );
  }

  customerHelpline(data: any): any {
    return this.httpClient.post(environment.url + "/customers/masters/customerHelpline", data);
  }

  getRecords(data: any): any {
    // return this.httpClient.post(environment.url + "/customers/masters/getRecords", data);
    return this.httpClient.post(environment.url + "/common/getRecords", data);

  }
}
